import { gql } from '@apollo/client';
export const marketPlansQuery = gql `
  query marketPlans($marketCode: String!) {
    plans(where: { market_code: { _eq: $marketCode } }) {
      id
      type
    }
  }
`;
